import React from "react";
import {useSelector} from "react-redux";
import VerticalNavigationBarItem from "../../../Navigation/VerticalNavigationBarItem";
import {useSettingsNavigationItems} from "../../../../Utils/navigationItemsHelper";

const SettingsMenuItems = ({}) => {
    const user = useSelector((state) => state.CommonReducer.user);
    const items = useSettingsNavigationItems(user);
    
    return (
        <>
            {items.filter(link => !link.hidden).map((item, index) => {
                return <VerticalNavigationBarItem key={index} link={item.link} disabled={item.disabled}  />
            })}
        </>
    );
}

export default SettingsMenuItems;